import { type DesignElementBase } from "..";
import { createIcon } from "../design-element-utils";

const designElement: DesignElementBase = {
  tags: [
    "pinterest",
    "Pinterest - Organic",
    "Pinterest Ads",
    "Pinterest Organic",
  ],
  iconColor: "#F05F33", // mars
  getIcon(options) {
    return createIcon(
      `
      <path
        d="M9.63842 17.4111C7.02713 16.3199 5.32732 13.2102 6.40834 10.0518C7.47771 6.92745 10.937 5.2913 14.0518 6.44798C17.1755 7.60796 18.7205 11.0547 17.5095 14.1444C16.2558 17.3432 12.8948 18.475 10.3748 17.677C10.5632 17.2117 10.7775 16.7525 10.9346 16.2746C11.0923 15.7946 11.1928 15.2959 11.3111 14.8339C11.4129 14.9195 11.5152 15.0104 11.6224 15.095C12.1793 15.5351 12.8092 15.5779 13.4693 15.4192C14.1706 15.2505 14.7249 14.8529 15.1353 14.2683C15.8295 13.2797 16.0745 12.1611 15.9068 10.9841C15.7332 9.76692 15.0126 8.88612 13.8828 8.44259C12.1804 7.77434 10.5667 7.99931 9.16878 9.22407C8.09369 10.166 7.73228 11.7629 8.24939 13.0061C8.42862 13.437 8.71187 13.7752 9.14041 13.9784C9.35759 14.0814 9.44978 14.0394 9.51263 13.8126C9.5173 13.7957 9.52298 13.779 9.52916 13.7626C9.64952 13.4453 9.62143 13.1843 9.40723 12.8779C9.0169 12.3195 9.08652 11.6731 9.27484 11.0537C9.63196 9.87913 10.6814 9.09543 11.912 9.08406C12.2417 9.081 12.5811 9.10927 12.9003 9.18717C13.85 9.41885 14.4632 10.1533 14.5246 11.127C14.5739 11.9079 14.4519 12.6665 14.1124 13.3795C13.9443 13.7326 13.7224 14.0465 13.3922 14.2687C13.082 14.4774 12.7428 14.5615 12.3748 14.4653C11.8677 14.3328 11.5799 13.8703 11.7081 13.3627C11.8411 12.8366 12.0131 12.3203 12.1434 11.7937C12.1986 11.571 12.2275 11.3291 12.2049 11.1022C12.1432 10.4843 11.5594 10.1961 11.0136 10.4978C10.6313 10.7091 10.4472 11.0623 10.3618 11.4709C10.2739 11.892 10.3165 12.3069 10.4535 12.7151C10.481 12.7972 10.4851 12.8986 10.4656 12.9832C10.2177 14.0645 9.95247 15.142 9.71763 16.2261C9.64909 16.5425 9.6618 16.8766 9.63902 17.2026C9.6347 17.2651 9.63842 17.3281 9.63842 17.4111Z"
        fill="#C9353D"
      />
      `,
      "#FDEFEB", // mars-2
      options?.borderColor || "#E0E2E6",
      options?.size || "24",
    );
  },
};

export default designElement;
